
const CommitmentSection = () => {
  return (
    <section className="py-16 bg-blue-600">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
            Commitment to Quality and Compliance
          </h2>
          
          <div className="space-y-6 text-lg text-blue-100 leading-relaxed mb-8">
            <p>
              We pride ourselves on delivering top-notch safety training that meets all OSHA requirements. We aim to help you create a safe work environment while ensuring compliance with all relevant regulations. By partnering with HP Inc Consulting Services, you can focus on your core business, knowing that your employees are well-trained and your workplace is safe.
            </p>
            
            <p>
              Comprehensive safety training is a legal requirement and an intelligent business decision. By partnering with HP Inc Consulting Services, you can ensure your employees have the training to work safely and efficiently while protecting your company from costly fines and legal liabilities. Contact us today to learn how we can help you build a safety culture within your organization.
            </p>
          </div>
          
          <button className="bg-white hover:bg-gray-100 text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer">
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default CommitmentSection;
